import dynamic from "next/dynamic";
import SelectableTagsWithCarouselGridConfig from "./selectable-tags-with-carousel-grid-config";
import SelectableTagsWithCarouselGridAdvancedConfig from "./selectable-tags-with-carousel-grid-advanced-config";
const SelectableTagsWithCarouselGridComponent = dynamic(()=>import("./selectable-tags-with-carousel-grid-component"));
export default {
    SelectableTagsWithCarouselGridComponent,
    SelectableTagsWithCarouselGridConfig,
    SelectableTagsWithCarouselGridAdvancedConfig
};
